/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHeadphonesIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-headphones"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.85 21.75L4.85 21.75Q3.75 21.75 2.98 20.98Q2.2 20.2 2.2 19.1L2.2 11.95Q2.2 9.93 2.98 8.15Q3.75 6.38 5.08 5.05Q6.4 3.73 8.19 2.96Q9.97 2.2 12 2.2Q14.03 2.2 15.81 2.96Q17.6 3.73 18.93 5.05Q20.25 6.38 21.02 8.15Q21.8 9.93 21.8 11.95L21.8 19.1Q21.8 20.2 21.02 20.98Q20.25 21.75 19.15 21.75L17.15 21.75Q16.02 21.75 15.26 20.99Q14.5 20.23 14.5 19.1L14.5 15.15Q14.5 14.03 15.26 13.26Q16.02 12.5 17.15 12.5L19.15 12.5L19.15 11.95Q19.15 9 17.06 6.92Q14.97 4.85 12 4.85Q9.03 4.85 6.94 6.92Q4.85 9 4.85 11.95L4.85 12.5L6.85 12.5Q7.97 12.5 8.74 13.26Q9.5 14.03 9.5 15.15L9.5 19.1Q9.5 20.23 8.74 20.99Q7.97 21.75 6.85 21.75Z" fill={color} />
    </svg>
  );
}
